import classnames from 'classnames';
import * as React from 'react';
import { observer } from 'mobx-react';

import { IViewMore } from 'src/core/components/view-more';

import styles from './estimate-description.less';

interface Props {
    viewMore: IViewMore;
}

export const EstimateDescription = observer<React.SFC<Props>>(
    ({ viewMore: { currentHtml, isExpanded, toggleExpanded, showViewMore, setTextDiv } }) => (
        <React.Fragment>
            <div
                className={classnames(styles.text, { [styles.expanded]: isExpanded })}
                dangerouslySetInnerHTML={{ __html: currentHtml }}
                ref={setTextDiv}
            />
            <a className={styles.viewMore} hidden={!showViewMore} onClick={toggleExpanded}>
                View {isExpanded ? 'Less' : 'More'}
            </a>
        </React.Fragment>
    )
);
